import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../../../utils/apiHelper";
import { toast } from "react-toastify";

export const submitApproval = createAsyncThunk(
    "approval/submit",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post("/startup/approval", { startupId });
            if (response.data.code === "00000") {
                toast.success('Başvurunuz başarıyla gönderildi');
                return response.data;
            }
            throw new Error("Approval submission failed");
        } catch (error) {
            toast.error('Başvuru gönderilirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

const approvalSlice = createSlice({
    name: "approval",
    initialState: {
        loading: false,
        error: null,
        success: false
    },
    reducers: {
        resetState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitApproval.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitApproval.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
                state.error = null;
            })
            .addCase(submitApproval.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { resetState } = approvalSlice.actions;
export default approvalSlice.reducer; 